/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';

/**
 * 
 * @export
 * @interface GetUserAddress200ResponseAllOfData
 */
export interface GetUserAddress200ResponseAllOfData {
    /**
     * 
     * @type {Address}
     * @memberof GetUserAddress200ResponseAllOfData
     */
    userAddress: Address;
}

/**
 * Check if a given object implements the GetUserAddress200ResponseAllOfData interface.
 */
export function instanceOfGetUserAddress200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userAddress" in value;

    return isInstance;
}

export function GetUserAddress200ResponseAllOfDataFromJSON(json: any): GetUserAddress200ResponseAllOfData {
    return GetUserAddress200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetUserAddress200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserAddress200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userAddress': AddressFromJSON(json['user_address']),
    };
}

export function GetUserAddress200ResponseAllOfDataToJSON(value?: GetUserAddress200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_address': AddressToJSON(value.userAddress),
    };
}

